var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersentase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 7,
    viewBox: "0 0 8 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.40016 0.586182L1.05297 3.93337C0.986952 3.99939 0.934579 4.07777 0.898848 4.16403C0.863117 4.25029 0.844727 4.34275 0.844727 4.43612C0.844727 4.52949 0.863117 4.62194 0.898848 4.70821C0.934579 4.79447 0.986952 4.87285 1.05297 4.93887C1.119 5.00489 1.19738 5.05727 1.28364 5.093C1.3699 5.12873 1.46236 5.14712 1.55573 5.14712C1.6491 5.14712 1.74155 5.12873 1.82781 5.093C1.91408 5.05727 1.99246 5.00489 2.05848 4.93887L3.68905 3.3083V8.70276C3.68905 8.89136 3.76397 9.07223 3.89733 9.20559C4.03069 9.33895 4.21156 9.41387 4.40016 9.41387C4.58875 9.41387 4.76963 9.33895 4.90299 9.20559C5.03635 9.07223 5.11127 8.89136 5.11127 8.70276V3.3083L6.74183 4.93887C6.80772 5.00514 6.88606 5.05772 6.97234 5.09361C7.05862 5.12949 7.15114 5.14796 7.24459 5.14796C7.33803 5.14796 7.43056 5.12949 7.51684 5.09361C7.60312 5.05772 7.68146 5.00514 7.74734 4.93887C7.81344 4.87289 7.86587 4.79452 7.90165 4.70825C7.93742 4.62199 7.95584 4.52951 7.95584 4.43612C7.95584 4.34273 7.93742 4.25025 7.90165 4.16398C7.86587 4.07771 7.81344 3.99935 7.74734 3.93337L4.40016 0.586182Z",
    fill: "#00B42A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersentase);
export default __webpack_public_path__ + "static/media/persentase.ae33f713ebce8961c0790293e754c09a.svg";
export { ForwardRef as ReactComponent };